<template>
  <AppModal v-model="dialog" v-bind="$attrs" :disableClose="loadingSubmit" max-width="500px" persistent :loading="loadingTemplates">
    <template v-slot:title>
      {{ appModalTitle }}
    </template>
    <template v-slot:text>
      <StaticContentForm :addForm="addForm" :value="value" :isValid.sync="formIsValid" :tenant-name="tenantName" ref="form" />
    </template>
    <template v-slot:actions>
      <v-spacer />
      <v-btn color="success" :disabled="!formIsValid" @click="submit" :loading="loadingSubmit">
        <v-icon left>done</v-icon>Save
      </v-btn>
      <v-btn @click="close" :disabled="loadingSubmit">Cancel</v-btn>
    </template>
  </AppModal>
</template>
<script>
  import StaticContentForm from '@/components/LandingPageStaticContent/Form/StaticContentForm'
  import {
    createNamespacedHelpers,
  } from 'vuex'
  const landingPageStaticContent = createNamespacedHelpers('landingPageStaticContent')
  export default {
    components: {
      StaticContentForm,
    },
    props: {
      tenantName: {
        type: String,
        default: '',
      },
      addForm: {
        type: Boolean,
        default: false,
      },
      value: {
        type: Object,
        default: () => {},
      },
    },
    data() {
      return {
        dialog: false,
        formIsValid: false,
        loadingSubmit: false,
      }
    },
    computed: {
      ...landingPageStaticContent.mapState(['templates']),
      appModalTitle() {
        return this.addForm ? 'Add Static Content Item' : 'Update Static Content Item'
      },
      loadingTemplates() {
        return (this.templates && this.templates.isLoading) || false
      },
    },
    methods: {
      show() {
        this.$refs.form.updateForm()
        this.dialog = true
      },
      close() {
        this.$refs.form.resetForm()
        this.dialog = false
      },
      async submit() {
        this.loadingSubmit = true
        try {
          await this.$refs.form.submit()
          this.close()
        } finally {
          this.loadingSubmit = false
        }
      },
    },
  }
</script>